//@ts-nocheck

import React from "react";

export const MESSAGES = {
  APP_VERSION: "Version: ${version}",
  FUNDING_AMT_AND_FACTOR_REQUIRED: "Funder, Funding Amount and Factor are mandatory.",
  BUSINESS_DATE_FORMAT: "Business Start Date should be in MM-DD-YYYY format.",
  ALREADY_EXISTS: " Already exists.",
  OWNER_FIELDS: "Following fields of the owner are mandatory.",
  BUSINESS_START_DATE_SHOULD_BE_LESS_THAN_TODAY: "Business Start Date should be less than today.",
  OFFER_DETAILS_REQUIRED: "Mandatory fields for Offer Details: ",
  MERCHANT_PRE_QUALIFICATION_REQUIRED: "Mandatory fields for Merchant Pre-Qualification: ",
  SUBMISSION: "Submission",
  UNDERWRITING: "Underwriting",
  OFFER_OUT: "Offer Out",
  DOC_REQUEST: "Doc Request",
  SEND_EMAIL_TEXT: "Send Mail & Decline",
  NO_MULTI_TENANTS: "No multiple tenants are available.",
  EMPTY_INVESTMENT_ACTIVITY_INFO: "Investment activity information is empty.",
  EMPTY_DEAL_ACTIVITY_INFO: "Deal Activity information is empty.",
  CONFIRM_DELETE: "Are you sure you want to disable?",
  DELETE_BANK: "Are you sure you want to delete this bank?",
  ACTUM_ORDER_NUMBER_REQUIRED: "Actum Order Number is mandatory",
  DEAL_NUMBER_REQUIRED: "Deal Number is mandatory",
  SELECT_ANY_ONE_RECORD: "Please select any one of the record.",
  SELECT_RECORD: "Please select a record.",
  SEARCH_FOR_DASHBOARD: "Search for Dashboards.",
  TRANSACTION_FETCHED: "Transaction fetched successfully.",
  DISABLED_BUTTON_TEMPORARY: "Temporarily disabled delete action.",
  NO_WEBHOOKS: "No Webhooks available.",
  ENTER_NUMBER_OF_DAYS: "Enter number of days",
  ALL_FIELDS_REQUIRED: "All fields mandatory.",
  PAUSE_DATE_REQUIRED: "Pause Date is mandatory.",
  SOMETHING_WRONG: "Something went wrong.",
  SELECT_SCHEDULE: "Please select the schedule.",
  SELECT_ABA_NO_CORRECTLY: "ABA Number is mandatory.",
  SELECT_ACC_NO_CORRECTLY: "Account Number is mandatory.",
  FUNDER_ACCOUNT_MANDATORY: "Funder Account is mandatory.",
  ENTER_BANK_NAME_CORRECTLY: "Bank Name is mandatory",
  MANDATORY_COLLECTING_AMOUNT: "Collecting Amount is mandatory",
  CORRECT_START_DATE_REQUIRED: "Start Date should be in MM-DD-YY format",
  TURN_OFF_ALL_DEBITS: "Turn Off All Schedule Debits.",
  UPDATE_INVESTMENT_COLLECTION_SCHEDULE: "Update investment collection schedule.",
  SELECT_INVESTMENT: "Please select a Investment.",
  CONFIRM_INITIATE_REFUND: "Are you sure you want to initiate refund?.",
  REFUND_NOT_INITITATED: "Refund couldn't be initiated, due to holiday.",
  CAN_NOT_ISSUE_REFUND_REQUEST: "Can't issue refund request on holiday.",
  CREDIT_REQUEST_ISSUED: "Credit request issued successfully.",
  REFUND_ISSUED: "Refund issued successfully.",
  MERCHANT_PAYMENT_ACC_DETAILS_REQUIRED: "Please enter payment account details for the merchant.",
  SUBMIT_TO_COLLECTION_WENT_WRONG: "Sorry. Something went wrong in submitting to collections.",
  AT_LEAST_ONE_EMAIL_REQUIRED: "At least one email is mandatory.",
  CONTRACT_GENARATED: "Contract generated successfully.",
  ARE_YOU_SURE: "Are you sure?",
  SELECT_MERCHANT: "Please select a Merchant.",
  MERCHANT_EXISTS: "Merchant already exists.",
  ENTER_FEDERAL_TAX_ID: "Federal Tax ID should be in xx-xxxxxxx format.",
  CHECK_BUSINESS_START_DATE_FORMAT: "Please check Date format of Business Start Date.",
  BUSINESS_START_DATE_LESS_THAN_TODAY: "Business Start Date should be less than today.",
  START_DATE_LATER_THAN_TODAY: "Start Date should be beyond today.",
  FUNDED_AMOUNT_PAY_BACK_FACTOR_FUNDER_REQUIRED:
    "Funded Amount, Payback Factor and Funder are mandatory.",
  FUNDING_AMOUNT_PAY_BACK_FACTOR_FUNDER_REQUIRED:
    "Funding Amount, Payback Factor and Funder are mandatory.",
  FUNDED_AMT_PAY_BACK_FACTOR_REQUIRED: "Funded Amount and Payback Factor are mandatory.",
  FUNDING_AMT_PAY_BACK_FACTOR_REQUIRED: "Funding Amount and Payback Factor are mandatory.",
  FUNDED_AMT_FUNDER_REQUIRED: "Funded Amount and Funder are mandatory.",
  FUNDING_AMT_FUNDER_REQUIRED: "Funding Amount and Funder are mandatory.",
  FUNDED_AMT_REQUIRED: "Funded Amount is mandatory.",
  FUNDING_AMT_REQUIRED: "Funding Amount is mandatory.",
  PAY_BACK_FACTOR_FUNDER_REQUIRED: "Payback Factor and Funder are mandatory.",
  PAY_BACK_FACTOR_REQUIRED: "Payback Factor is mandatory",
  FUNDER_REQUIRED: "Funder is mandatory.",
  AT_LEAST_ONE_OWNER_REQUIRED: "At least one Owner is mandatory.",
  PROFIT_SHARE_PERCENTAGE_NOT_GREATER_THAN_HUNDRED:
    "Profit share percentage should not be more than 100%.",
  DATE_BEYOND_FUNDING_DATE: "Date should be beyond Funding Date.",
  FILL_MANDATORY_FIELDS: "Please fill out the mandatory fields.",
  LETTER_NOT_CONFIG: "This letter is not yet configured.",
  FILL_MANDATORY_FIELD: "Please fill the field ${field}",
  SUCCESS_DEBIT_INSTRUCTION: "Debit Instruction issued Successfully.",
  SUCCESS_SCHEDULE_RUN: "Collection schedules got triggered.",
  FAILED_DEBIT_INSTRUCTION: "Debit Instruction issuing Failed because of ${reason}",
  START_DATE_NOT_SATURDAY_OR_SUNDAY: "Start Date should not be Saturday or Sunday.",
  SELECT_ROW: "Please select a row.",
  SELECT_MERCHANT_FIRST: "Please select Merchant first.",
  CONFIRM_DEAL_HISTORICAL_FEES_UPDATE: "Do you want to update Fees for historical Deals?",
  CHECK_AFTER_MANAGEMENT_FEE_FOR_DEAL: "Please check after update of management fee for Deals.",
  INVESTMENT_AMT_REQUIRED: "Investment Amount is mandatory",
  DEPOSIT_AMT_REQUIRED: "Deposit Amount is mandatory",
  TRANSACTION_DATE_REQUIRED: "Transaction Date is mandatory.",
  WITHDRAL_AMT_REQUIRED: "Withdraw Amount is mandatory.",
  STOP_DATE_BEYOND_START_DATE: "Stop Date should be beyond Start Date.",
  STOP_DATE_EARLIER_OF_END_DATE: "Stop Date should be earlier than End Date.",
  STOP_DATE_BEYOND_TODAY: "Stop Date should be beyond today.",
  CAN_NOT_DELETE_RUNNING_SCHEDULE:
    "Sorry. A running schedule cannot be deleted. You can Pause or Stop the schedule.",
  CAN_NOT_DELETE_EXISTING_SCHEDULE:
    "Sorry. A running schedule cannot be deleted. You can Pause or Stop the schedule.",
  START_DATE_CURRENT_DAY_OR_PREV_DATE: "Start Date should not be the Previous Date.",
  START_DATE_SHOULD_NOT_BE_SAT_OR_SUN: "Start Date should not be Saturday or Sunday.",
  END_DATE_BEYOND_START_DATE: "End Date should be beyond Start Date.",
  FREQUENCY_REQUIRED: "Frequency is mandatory.",
  COLLECTION_TOWARDS_REQUIRED: "Collection Towards is mandatory.",
  MODE_OF_PAYMENT_REQUIRED: "Mode Of Payment is mandatory.",
  CORRECT_RECURRING_AMT_REQUIRED: "Recurring Amount is mandatory.",
  CAN_NOT_SELECT_SAME_DAY_AFTER_10_45_AM:
    "Sorry. The cut off time for setting up same day schedule is 10.45AM EST.",
  END_DATE_REQUIRED: "End Date is mandatory",
  ALL_DYNAMIC_PAYMENTFIELD_REQUIRED: "Following fields of the Dynamic Payment are mandatory.",
  NO_RECORD_TO_SAVE: "No record selected to save.",
  EXPECTED_PAYMENT_DATE_REQUIRED: "Expected Payment Date is mandatory.",
  EXPECTED_PAYMENT_AMOUNT_REQUIRED: "Expected Payment Amount is mandatory.",
  AT_LEAST_ONE_RECORD_REQUIRED: "At least one record is mandatory.",
  ADD_MANUAL_TRACK_PAYMENT: "Add Manual Track Payment.",
  CONFIRM_TRANSACTION_DELETE: "Are you sure you want to delete this transaction?",
  UNABLE_TO_CREATE_TRANSACTION: "Something went wrong, unable to create transaction.",
  FROM_DATE_REQUIRED: "From Date is mandatory.",
  TO_DATE_REQUIRED: "To Date is mandatory.",
  END_DATE_GREATER_THAN_OR_EQUAL_TO_FROM_DATE:
    "End Date should be greater than or equal to From Date.",
  TO_DATE_GREATER_THAN_OR_EQ_FROM_DATE: "To Date should be greater than or equal to From Date.",
  CONFIRM_TRANSACTION_IGNORE: "Are you sure you want to ignore this transaction?",
  CONFIRM_TRANSACTION_UNTAG: "Are you sure you want to untag this transaction?",
  CONFIRM_TAGGED_TRANSACTION_DECLINE:
    "Are you sure you want to decline this auto tagged transaction?",
  UANBLE_TO_DELETE_COMMISSION: "Something went wrong, unable to delete commission.",
  MANAGE_INVESTMENT_PERCENTAGE:
    "Investment percentage  should not cross 100 % please manage investment percentage !",
  CONFIRM_APPROVE: "Are you sure you want to approve?",
  BUSINESS_LEGAL_NAME_REQUIRED: "Business Legal Name is mandatory.",
  FEDARAL_TAX_ID_FORMAT: "Federal Tax ID should be in xx-xxxxxxx format.",
  CONFIRM_PROCEED: "Are you sure you want to proceed.",
  ADJUST_SYNDICATED_AMT_TO_FUNDING_AMT: "Please adjust Syndicated Amount to match Funding Amount.",
  MCA_REQUIRED: "Please select or add new MCA.",
  FUNDER_AND_FUNDED_AMT_REQUIRED: "Funder and Funded Amount are mandatory.",
  PERCENTAGE_NOT_GREATER_THAN_HUNDRED: "Percentage should not be greater than 100.",
  START_DATE_BEYOND_TODAY: "Start Date should be beyond today.",
  PERCENTAGE_SHOULD_BE_LESS_THAN_HUNDRED: "Percentage should be less than 100%.",
  FUNDING_AMOUNT_NO_EMPTY_OR_ZERO: "Funding Amount can't be empty and should be greater than zero.",
  CONFIRM_COMMISSION_TRANSACTION_UPDATE: "Are you sure you want to update commission transactions?",
  INVALID_PURCHASE_PERCENTAGE: "Invalid % of purchase.",
  INVALID_TRANSACTION_PERCENTAGE: "Invalid % transaction.",
  NO_TRANSACTION_FOUND: "No Transactions found.",
  NO_DEALS_FOUND: "No Deals found.",
  EMAIL_NOT_FOUND: "Email not found.",
  USER_CAN_NOT_DELETE: "User can't be deleted.",
  USER_ADDED_SUCCESSFUL: "User added successfully.",
  FIRST_NAME_REQUIRE_MIN_TWO_CHAR: "First Name should have at least two characters.",
  LAST_NAME_REQUIRE_MIN_TWO_CHAR: "Last Name should have at least two characters.",
  PASSWORD_REQUIRE_MIN_SIX_CHAR: "Password should have atleast 6 characters.",
  EMAIL_MUST_WELL_FORMED: "Email must be a well-formed email address.",
  ROLE_REQUIRED: "Role should not be empty.",
  PARTY_REQUIRED: "Party is mandatory.",
  SELECT_AT_LEAST_ONE_MERCHANT: "At least one Merchant is mandatory.",
  CONFIRM_DEBIT_REQUEST_DEAL_REVOKE:
    "Are you sure you want to revoke all debit requests of this deal?",
  CONFIRM_REVOKE_REQUEST: "Are you sure you want to revoke this request?",
  NOTIFY_REFI_DEAL_DELETE: "Refinanced deal can not be deleted.",
  START_DATE_REQUIRED: "Start Date is mandatory.",
  END_DATE_LATER_THAN_START_DATE: "End Date should be beyond Start Date.",
  PAUSE_DATE_BEYOND_START_DATE: "Pause Date should be beyond Start Date.",
  PAUSE_DATE_LATER_THAN_TODAY: "Pause Date should be beyond today.",
  END_DATE_LATER_THAN_TODAY: "End Date should be beyond today.",
  PAUSE_DATE_SHOULD_NOT_BE_SATURDAY_OR_SUNDAY: "Pause Date should not be Saturday or Sunday.",
  RESUME_DATE_BEYOND_PAUSE_DATE: "Resume Date should be beyond Pause Date.",
  RESUME_DATE_EARLIER_THAN_END_DATE: "Resume Date should be earlier than End Date.",
  RESUME_DATE_SHOULD_NOT_BE_SATURDAY_OR_SUNDAY: "Resume Date should not be Saturday or Sunday.",
  PAUSE_DATE_CANNOT_BEYOND_END_DATE: "Pause Date cannot be beyond End Date.",
  PAUSE_DATE_BEYOND_CUT_OFF_TIME: "Pause Date cannot be set as tomorrow after cut off time.",
  END_DATE_BEYOND_CUT_OFF_TIME: "End Date cannot be set as tomorrow after cut off time.",
  CAN_NOT_DATE_RUNNING_SCHEDULE:
    "Sorry. A running schedule cannot be deleted. You can Pause or Stop the schedule",
  CORRECT_END_DATE_REQUIRED: "End Date is mandatory",
  COLLECTION_SCHEDULE_REQUIRED: "Collection schedule is mandatory.",
  CONTACT_PERSON_REQUIRED: "Contact person is mandatory.",
  NAME_REQUIRED: "Name is mandatory.",
  EMAIL_FORMAT: "Email format should be john@doe.com.",
  MOBILE_NUMBER_FORMAT_1: "Ex: xxx-xxx-xxxx",
  MOBILE_NUMBER_FORMAT_2: "Ex: (xxx) xxx-xxxx",
  BANK_NAME_REQUIRED: "Bank name is mandatory.",
  ABA_NUMBER_REQUIRED: "ABA number is mandatory.",
  ACCOUNT_NUMBER_REQUIRED: "Account number is mandatory.",
  FUNDER_PREFIX_REQUIRED: "Funder Prefix is mandatory.",
  FUNDER_PREFIX_LENGTH_IS_THREE: "Funder Prefix should be of three characters.",
  SYNDICATOR_OR_BROKER_REQUIRED: "Syndicator or Broker is mandatory.",
  UNABLE_TO_DOWNLOAD_FILE: "Something went wrong, unable to download file.",
  COLLECTION_SCHEDULE_DATE_SHOULD_NOT_BE_CURRENT_OR_PREVIOUS_DATE:
    "Collection Schedule Start Date should not be previous Date.",
  COLLECTION_SCHEDULE_DATE_SHOULD_NOT_BE_SATURDAY_OR_SUNDAY:
    "Collection Schedule Start Date should not be Saturday or Sunday.",
  CONFIRM_TRANSACTION_APPROVE: "Are you sure you want to approve this Transaction?",
  UNABLE_TO_UPDATE_TRANSACTION: "Something went wrong, unable to update Transaction.",
  CONFIRM_DEAL_DELETE: "Are you sure you want to delete this Deal?",
  CONFIRM_REVOKE: "Are you sure you want to undo import ?",
  SUCCES_REVOKE: "Undo import successful.",
  DEAL_REQUIRED: "Deal is mandatory.",
  PER_TRANSACTION_COMMISSION_SHOULD_BE_LESS_THAN_HUNDRED:
    "Per transaction commission percentage should be less than 100%.",
  TOTAL_FUND_CROSSING_HUNDRED: "Total % fund entered is crossing 100%.",
  TOTAL_FUND_SHOULD_BE_HUNDRED: "Total % fund entered should be 100%",
  CORRECT_PERCENTAGE_OR_AMOUNT_REQUIRED:
    "Please enter correct percentage or amount to match funding amount.",
  BROKER_COMMISSION_TYPE_REQUIRED: "Broker commission type is mandatory",
  SYNDICATOR_FEE_TYPE_REQUIRED: "Syndicator Fee type is mandatory.",
  FEE_AMOUNT_REQUIRED: "Fee Amount is mandatory.",
  PURCHASE_PERCENTAGE_CROSSES_HUNDRED: "% of purchase is crossing 100%.",
  PURCHASE_PERCENTAGE_REQUIRED: "% of purchase is mandatory.",
  IS_MANDATORY: "% is mandatory.",
  AMOUNT_TYPE_MANDATORY: "Amount Type is mandatory",
  PROFIT_PERCENTAGE_REQUIRED: "% of profit should be greater than 0",
  TRANSACTION_PERCENTAGE_REQUIRED: "% of transaction is mandatory.",
  TRANSACTION_PERCENTAGE_GREATER_THAN_ZERO: "% of transaction should be greater than zero.",
  PURCHASE_PERCENTAGE_GREATER_THAN_ZERO: "% of purchase should be greater than zero.",
  TRANSACTION_PERCENTAGE_CROSSES_HUNDRED: "% of transaction is crossing 100%.",
  FUND_CROSSES_HUNDRED: "% fund entered is crossing 100%",
  CHECK_FORMAT_OF_BUSINESS_START_DATE: "Business Start Date should be in MM-DD-YYYY format.",
  BUSINESS_START_DATE_NOT_GREATER_TODAY: "Business Start Date should not be greater than today.",
  CHECK_OWNER_DATE_FORMAT: "Owner Date of Birth should be in MM-DD-YYYY format.",
  CHECK_OWNERS_DATE_FORMAT: "Owners Date of Birth should be in MM-DD-YYYY format.",
  AGE_GREATER_THAN_EIGHTEEN: "Age should be above 18 years.",
  OWNER_AGE_GREATER_THAN_EIGHTEEN: "Owner age should be above 18 years.",
  DATE_LESS_THAN_TODAY: "Date should be less than today.",
  CONFIRM_IMPORT: "Are you sure you want to import?",
  INVESTER_REQUIRED: "Investor is mandatory.",
  NO_REPORTS: "No reports found.",
  UPDATE_FAILED: "Update failed, something went wrong.",
  NO_BUSINESS_OWNER_REPORTS: "Business Owner Background Report not available.",
  INVESTMENT_PERCENTAGE_NOT_GREATER_THAN_HUNDRED:
    "Investment Percentage should not be more than 100%.",
  SUCCESSFUL_UPDATE: "Updated successfully.",
  MERCHANT_AND_OFFER_DETAILS_REQUIRED: "Merchant and Offer details are mandatory.",
  INVALID_DISCOUNT_AMOUNT: "Invalid Discount Amount.",
  CONFIG_FUNDER_CREDENTIALS: "Configure ACH credentials for the selected funder.",
  PARENT_DEAL_AMOUNT_VALID: "Net funded amount of child deal should not be negative.",
  CONTACT_ADMINISTRATION: "Unable to complete. Please contact Administration!",
  CONFIRM_DEAL_CLOSE: "Are you sure you want to close this Deal?",
  INVESTMENT_NEGITIVE_FOR_FUNDER: "Investment percentage going negative for funder.",
  NET_FUNDED_NEGITIVE: "Net funded amount can't be negative.",
  CONFIRM_DEAL_CLOSE_WHILE_ACTIVE_DEBIT:
    "There is an active debit schedule for the closed deal ${dealNo}. Do you want to end the schedule?",
  CONFIRM_DEAL_REFINANCE_WHILE_ACTIVE_DEBIT:
    "There is an active debit schedule for the refinanced deal ${dealNo}. Do you want to end the schedule?",
  CONFIRM_DEAL_REFINANCE: "Are you sure you want to Refinance this Deal?",
  INVALID_EMAIL_OR_PASSWORD: "Invalid email or password.",
  SOMETHING_WRONG_TRY_AGAIN: "Sorry, something went wrong. Please try again.",
  REFINANCE_AMOUNT_REQUIRED: "Refinance amount is mandatory.",
  NAME_SHOULD_HAVE_THREE_CHARACTERS: "Name should have at least three characters",
  SHOULD_ADD_AT_LEAST_ONE_FILE: "Should add at least one file.",
  DEAL_AND_PARTY_AND_TRANSACTION_CSV_SHOULD_UPLOAD_TOGETHER:
    "Deals, Deal Parties and Deal Transactions CSVs should upload together",
  TOKEN_EXPIRED: "Your access token has expired. Please reload the Pages to continue.",
  PLEASE_ENTER_WITHDRAW_AMOUNT: "Withdraw Amount is mandatory",
  PLEASE_ENTER_POSITIVE_AMOUNT: "Please Enter Positive Amount",
  PLEASE_ENTER_AMOUNT: "Please Enter Transaction Amount.",
  PLEASE_SELECT_PROCESSER_PARTY: "Please Select Processor Party Details.",
  PLEASE_SELECT_CATEGORY_TYPE: "Please Select Category typr.",
  SIMILAR_TRXNS: "Similar transactions are also available, do you want to tag those transactions?",
  READJUST_THESE_FEES_AS_PER_THE_LATEST_SYNDICATION:
    "Some fees are collected upfront from syndicators that are not proportionate to their investment. You may want to readjust these fees as per the latest syndication",
  FEE_AMOUNT_SHARING_MUST_BE_VALID: "Total sharing must be equal to transaction amount",
  FEE_AMOUNT_HAS_NEGATIVE_VALUE: "Fee amount collected from syndicators must be positive",
  SERVER_EXCEPTION_MESSAGES: {
    TITLE: "Internal Server Error",
    DEAL_CONFLICT_TITLE: "Deal Modified",
    MESSAGE: "There was an error while processing the request, please contact your admin.",
    DEAL_CONFLICT_MESSAGE:
      "Deal modified by another user. Refresh the deal to view the latest details before making any changes.",
    APP_CONFLICT_TITLE: "Deal Application Status Modified",
    APP_CONFLICT_MSG:
      "Application status modified by another user. Refresh the application to view the latest status before updating the status.",
  },
  SERVICE_UNAVAILABLE_MESSAGES: {
    TITLE: "Service is Unavailable",
    MESSAGE: "The service is temporarily unavailable. Please check back shortly.",
  },
  SYNDICATOR_ROLE_PARTY_LINK_MESSAGE: "Party is mandatory for Syndicator Role.",
  INVESTMENT_PERCENTAGE: "Total Syndicators Investment Percentage Should be 100",
  TENANT_FEATURE_MESSAGES: {
    TENANT_CONFIG_COUNT:
      "You have reached the maximum number of users allowed for this tenant. Please contact the admin.",
    ROLE_CONFIG_COUNT:
      "You have reached the maximum number of users allowed for this role. Please contact the admin",
    DASHBOARD: {
      TITLE: "Dashboard",
      MESSAGE: "This feature is not available for this tenant. Please contact the admin.",
    },
    SYNDICATOR_LOGIN: {
      TITLE: "Syndicator Login",
      MESSAGE: "This feature is not available for this tenant. Please contact the admin.",
    },
    BACKGROUND_CHECK: {
      TITLE: "Background Check",
      MESSAGE: "This feature is not available for this tenant. Please contact the admin.",
    },
    BANK_INTEGRATION: {
      TITLE: "Bank Integration",
      MESSAGE: "This feature is not available for this tenant. Please contact the admin.",
    },
  },
  DATA_Merch: {
    TITLE: "Data Merch",
    MESSAGE:
      "This feature may not be available or incorrectly configured. Please contact the admin.",
  },
  ALREADY_SYNDICATOR: "This broker is already a syndicator",
  SAME_DAY_CUTOFF_TIME:
    "Sorry. The cut off time for setting up same day schedule is ${hour}:${minute}(${zone})",
  BANK_FEE_ALERT_MESSAGE:
    "Do you want the investor's bank fee amount to be updated based on the new investment percentage?",
  TOTAL_BANK_FEE_EXCEED_MESSAGE: "Investor bank fee should not exceeds total bank fee Amount.",
  BANK_FEE_INVESTORS_SHARE_MESSAGE: "Bank fee share of syndicators updated.",
  PAYMENT_SCHEDULE_CAN_NOT_BE_HOLIDAY: "Start Date should not be a banking holiday",
  PLEASE_ENTER_COLLECTION_INFO_FIELDS: "Please Fill Out Following Collection Info Fields: ",
  DAILY_CUTOFF_TIME:
    "Sorry. The cut off time for setting up today start date schedule is ${hour}:${minute}(${zone})",
  ONE_TIME_VALIDATION: "Start date should be later than today for 'one time debit' frequency",
  DATE_CHANGE: "Do you want to revoke the instructions, if already issued for this schedule?",
  DELETE_SCHEDULE:
    "This schedule cannot be deleted as the cut off time to revoke the instruction has crossed",
  REVOKE_FAILED: "This schedule cannot be deleted because instructions can't be revoked",
  DATE_UPDATE: "Can't modify ${type} because instructions can't be revoked",
  CANNOT_CHANGE_DATE_OLD_TO_NEW_BEYOND_CUT_OFF:
    "${type} cannot be changed from ${previousDate} to ${newDate} after the cut off time.",
  CANNOT_CHANGE_DATE_OLD_TO_NEW: "${type} cannot be changed from ${previousDate} to ${newDate}.",
  CANNOT_CHANGE_THE_PAST_DATE_FUTURE:
    "This schedule has already been paused once in the past. A schedule can only be paused once, due to audit " +
    "history limitations. If you need to pause this schedule again, please end the schedule on the date you wish to pause and create a new one to start on the date you wish to resume.",
  CANNOT_MODIFY_DATE: "${type} cannot be modified as the instructions can't be revoked.",
  SCHEDULE_DATES_CAN_NOT_BE_HOLIDAY: "${type} should not be a bank holiday",
  DELETE_SCHEDULE_PENDING_OR_SUCCESSFUL_STATUS:
    "This schedule cannot be deleted because instruction is already issued to bank.",
  ACCOUNT_DETAILS_CUTOFF_TIME_CROSSED: "Account Details cannot be modified beyond the cutoff time.",
  ACCOUNT_DETAILS_FOR_FUTURE_ONLY:
    "Account Details modification will be affected for future debits only.",
  TURN_OFF_ALL_DEBITS_ALERT: "Are you sure, you want pause all the schedules.",
  CANNOT_REVOKE_BEFORE_HOLIDAY_DATE:
    "Debit instruction got issued for ${dates} cannot be revoked as the cut off time has crossed. This settings will be applied for future holidays.",
  CANNOT_ISSUE_BEFORE_HOLIDAY_DATE:
    "Debit instruction cannot be issued for ${dates} as the cut off time has crossed. This settings will be applied for future holidays.",
  PAUSE_DATE_NOT_UPDATED: "Pause date is not updated as there is no active schedule.",
  PAUSE_DATE_UPDATED_FOR_PARTIAL_SCHEDULES:
    "Pause date updated for partial schedules. Check payment schedules for more info.",
  ALLOW_OVER_COLLECTED_CONFIRM_MSG:
    "Update of syndicator account is triggered in the background. " +
    "You can verify the accounting data after few minutes.",
  PLEASE_ADJUST_FUNDING_AMOUNT: "Please adjust the funding amount.",
  BANK_FEE_DISTRIBUTION_ALERT:
    "Bank fee cannot be given to syndicator as it exceeds the total bank fee amount.",
  EXTERNAL_IDENTIFIER_EXISTS: "External identifier already exists.",
  MASTER_LEDGER_SYNDICATOR_REPORT_ALERT:
    "Report generation initiated in the background and will be emailed to you on completion.",
  PERMISSION_NOT_EXISTS: "Permission does not exists, please contact admin.",
  POSITIVE_INTEGER: "Value should be positive integer.",
  REFINANCE_APPLICATION_VALIDATION_ERROR:
    "You cannot remove all paying off deals of Refinance application.",
  FAILED_REVOKE_MESSAGE:
    "Some debit instructions could not be revoked. Please check your email for details and take necessary actions.",
  DEAL_DELETION_STATUS: "Deal has been deleted successfully",
  UNDO_STATUS: "Undo Deal has been successful",
  AUDIT_FILTER_VALIDATION: "Data can't be filtered by action alone, Please enter the key also",
  DELETE_CUSTOM_DEAL_MSG: (
    <div style={{ padding: "10px" }}>
      <br /> <b> Debit Instructions: </b> <br />
      1. All ACH collection schedules of this deal will come to an end. <br />
      2. Debit instruction(s) of this deal that are issued today will be revoked if the deal is
      deleted before the ACH cut off time for revocation. <br />
      3. Debit instruction(s) of this deal that are already issued (but not revocable) and pending
      to be collected will be sent in an email for your reference. <br />
      4. The collection status of these pending debit instructions will not be processed by the
      system. Instead the status of these instructions will be emailed to you as and when the system
      receives the status updates from ACH processor. You need to act on them as needed by creating
      manual payments/bounces against an appropriate deal.
      <br />
      <br /> <b> Transactions: </b> <br />
      1. All transactions of this deal will be deleted permanently.
      <br />
      2. All Syndicator/Broker/Funder accounting records for this deal will be deleted permanently.
      <br />
      <br /> <b> Payments: </b> <br />
      1. Download the payment history of this deal by clicking on the &quot;Payment History&quot;
      option in the Transactions tab of the deal.
      <br />
      2. You can refer to this report to recreate these payments against an appropriate deal.
      <br />
      <br /> <b>Refinances: </b> <br />
      1. In case of refinance, the parent deal(s) will be reopened and their refinance incoming
      transactions will be deleted.
      <br />
      <br /> <b> Balance Transfers: </b> <br />
      1. Any Balance Transferred transaction(s) to/from this deal will be deleted.
      <br />
      2. The counter Balance Transferred transaction(s) to/from another deal will also be deleted.
      <br />
      3. The counter Balance Transferred transactions that are deleted from other deal(s) will be
      emailed for your reference.
      <br />
      <br />
      Note: You could also contact the support team to make the changes you want to do as opposed to
      completely deleting the deal.
      <br /> <br />
    </div>
  ),
  DELETE_DEAL_MSG: (
    <div style={{ padding: "10px" }}>
      <br /> <b> Transactions: </b> <br />
      1. All transactions of this deal will be deleted permanently.
      <br />
      2. All Syndicator/Broker/Funder accounting records for this deal will be deleted permanently.
      <br />
      <br /> <b> Payments: </b> <br />
      1. Download the payment history of this deal by clicking on the &quot;Payment History&quot;
      option in the Transactions tab of the deal.
      <br />
      2. You can refer to this report to recreate these payments against an appropriate deal.
      <br />
      <br /> <b>Refinances: </b> <br />
      1. In case of refinance, the parent deal(s) will be reopened and their refinance incoming
      transactions will be deleted.
      <br />
      <br /> <b> Balance Transfers: </b> <br />
      1. Any Balance Transferred transaction(s) to/from this deal will be deleted.
      <br />
      2. The counter Balance Transferred transaction(s) to/from another deal will also be deleted.
      <br />
      3. The counter Balance Transferred transactions that are deleted from other deal(s) will be
      emailed for your reference.
      <br />
      <br />
      Note: You could also contact the support team to make the changes you want to do as opposed to
      completely deleting the deal.
      <br /> <br />
    </div>
  ),

  UPDATE_TERMS_FUNDER_INFO: (
    <div style={{ padding: "10px" }}>
      <b>
        <font color="#ff0000">
          {" "}
          Please review the following information carefully before proceeding to change the funder.{" "}
        </font>
      </b>{" "}
      <br />
      <br />
      <br /> <b>Deal Number:</b>
      <br />
      1. The Deal Number will be changed to reflect the current funder of the deal.
      <br />
      <br /> <b>Transactions:</b>
      <br />
      <br /> <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Investment:</b> <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. The investment transaction of the old funder will be
      removed.
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. A new investment transaction will be created with the
      new funder’s account.
      <br />
      <br />
      <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Payments:</b>
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. All payment shares given to the old funder will be
      transferred to the new funder.
      <br />
      <br />
      <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Refunds/Balance Transfers:</b>
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. All debits done for refunds/balance transfers from the
      old funder will be &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;transferred to the new funder.
      <br />
      <br />
      <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Heldbacks:</b>
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. All heldback transactions (bank fee, heldback) of the
      old funder will be &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;transferred to the new funder.
      <br />
      <br />
      <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Commissions/PSFs:</b>
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. Any debits done for commission / psf to brokers will be
      changed from the old <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;funder’s account to the new funder’s account.
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. Any “In-house commission” given to the old funder will
      not be canceled.
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. No new automatic “In-house commission” will be given to
      the new Funder.
      <br />
      <br />
      <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Syndicator Fees:</b>
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. Any syndicator fees credited to the old funder will be
      transferred to the
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;new funder.
      <br />
      <br />
      <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Broker Commission collected from syndicators:</b>
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. Commission obligation collected as fees from
      syndicators and credited to the <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;old funder will be transferred to the new funder.
      <br />
      <br />
      <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Special Fees:</b>
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. Any special fees collected through ACH will be
      transferred from the old funder <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;to the new funder.
      <br />
      <br />
      <b>Debit Instructions:</b>
      <br />
      1. Already issued debit instructions will be credited to the old funder’s bank account by ACH.
      <br />
      2. However, in SmartMCA the payment share for those instructions will be given to the new
      funder.
      <br />
      3. Any new debit instructions will be issued from the new funder’s ACH account.
      <br />
      <br />
      <b>External Schedule Identifier to Deal Number Mapping:</b>
      <br />
      1. For tenants that are not using automatic ACH integration and instead using manual ACH
      imports, the deal number will be automatically updated in the “External schedule identifier to
      Deal Number mappings” so that the ACH imports continue to work for them.
      <br />
      <br />
      <b>Deal Application:</b>
      <br />
      1. The deal application of this deal will not be changed. It will continue to refer to the old
      Funder.
      <br />
    </div>
  ),

  Funder_CHANGE_INVESTOR_ALERT: (
    <div>
      <br />
      <b>&nbsp;&nbsp;Existing Investor:</b>
      <br />
      <br />
      &nbsp;&nbsp;If the new funder or default syndicator is already an investor of this deal,
      follow the below &nbsp;&nbsp;steps.
      <br />
      &nbsp;&nbsp;1. Remove the investor from this deal’s syndicators list so that his investment
      gets added <br />
      &nbsp;&nbsp;to the old funder.
      <br />
      &nbsp;&nbsp;2. Change the funder to the new funder.
      <br />
      <br />
    </div>
  ),
  MANUAL_SUB_STATUS_CHANGE_MSG:
    "You have chosen to manually maintain the sub status of this deal. Going forward, system will not automatically calculate and update the sub status of this deal.",

  UNDO_DEAL_MSG: (
    <div style={{ padding: "10px" }}>
      <br /> <b> Application: </b> <br />
      1. Application substatus will be set back to `Pending Final Approval`.
    </div>
  ),

  UPDATE_TERMS_FUNDED_AMOUNT_INFO: (
    <div style={{ padding: "10px" }}>
      <b>
        <font color="#ff0000">
          {" "}
          Please review the following information carefully before proceeding to change the funded
          amount.
        </font>
      </b>{" "}
      <br />
      <br /> <b> Deal Parameters: </b> <br /> <br />
      The below parameters of the deal will be updated when the funded amount is changed.
      <br />
      &nbsp;&nbsp;1. Purchase Amount
      <br />
      &nbsp;&nbsp;2. Net Funded Amount
      <br />
      &nbsp;&nbsp;3. Starting Cash Exposure
      <br />
      &nbsp;&nbsp;4. Current Cash Exposure
      <br />
      &nbsp;&nbsp;5. Outstanding Amount
      <br />
      &nbsp;&nbsp;6. P&L
      <br />
      <br /> <b> Funder’s Parameters: </b> <br /> <br />
      The below parameters of the funder will be updated when the funded amount is changed
      <br />
      &nbsp;&nbsp;1. The investment amount of the funder will increase/decrease to the same extent{" "}
      <br />
      &nbsp;&nbsp;of the increase/decrease in the deal funded amount.
      <br />
      &nbsp;&nbsp;2. Cash Exposure
      <br />
      &nbsp;&nbsp;3. Cash collected: Payments will be redistributed based on the new percentage of{" "}
      <br />
      &nbsp;&nbsp;investment
      <br />
      &nbsp;&nbsp;4. P&L
      <br />
      &nbsp;&nbsp;5. Outstanding Amount
      <br />
      <br /> <b> Syndicator Parameters: </b> <br /> <br />
      The Funded Amount of syndicators will remain unchanged.
      <br />
      The below parameters of the syndicators will be updated when the funded amount is changed
      <br />
      &nbsp;&nbsp;1. Investment Percentage
      <br />
      &nbsp;&nbsp;2. Bank Fee (based on new percentage)
      <br />
      &nbsp;&nbsp;3. Commission Obligation (based on new percentage)
      <br />
      &nbsp;&nbsp;4. Cash collected: Payments will be redistributed based on the new percentage of
      &nbsp;&nbsp;investment
      <br />
      &nbsp;&nbsp;5. P&L
      <br />
      &nbsp;&nbsp;6. Outstanding Amount
      <br />
      <br /> <b> Bank Fee: </b> <br /> <br />
      &nbsp;&nbsp;1. Deal’s Total bank fee will not be updated.
      <br />
      &nbsp;&nbsp;2. However the bank fee share of funder and investors will be updated based on{" "}
      <br />
      &nbsp;&nbsp; their new investment percentage.
      <br />
      <br /> <b> Broker Commission: </b> <br />
      <br />
      &nbsp;&nbsp;1. Broker Commission (inhouse/external) will not be updated by the system.
      <br />
      &nbsp;&nbsp;2. User has to manually do any changes required in the broker commission.
      <br />
    </div>
  ),

  UPDATE_TERMS_PAYBACK_INFO: (
    <div style={{ padding: "10px" }}>
      <b>
        <font color="#ff0000">
          {" "}
          Please review the following information carefully before proceeding to change the payback
          factor.
        </font>
      </b>{" "}
      <br />
      <br /> <b> Deal Parameters: </b> <br />
      <br />
      The below parameters of the deal will be updated when the payback factor is changed.
      <br />
      &nbsp;&nbsp;1. Purchase Amount
      <br />
      &nbsp;&nbsp;2. Outstanding Amount
      <br />
      &nbsp;&nbsp;3. P&L
      <br />
      <br /> <b> Syndicator Parameters: </b> <br />
      <br />
      The below parameters of the syndicators will be updated when the payback factor is changed.
      <br />
      &nbsp;&nbsp;1. Expected Profit
      <br />
      &nbsp;&nbsp;2. Outstanding
      <br />
      &nbsp;&nbsp;3. P&L
      <br />
      &nbsp;&nbsp;4. Cash Collected :<br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cash collected will be
      updated when the payment share already given to <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;the syndicator becomes
      either under collected or over collected due <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;to change in the
      payback factor.
      <br />
      &nbsp;&nbsp;5. Promote Paid: Any promote fees defined based on the purchase amount <br />
      &nbsp;&nbsp; will be revised based on the new purchase amount.
      <br />
      <br /> <b> Broker Commission: </b> <br />
      <br />
      &nbsp;&nbsp;1. Any default broker commission added previously based on the purchase amount{" "}
      <br />
      &nbsp;&nbsp;will not be changed.
      <br />
      &nbsp;&nbsp;2. User has to manually do any changes required in the broker commission.
      <br />
    </div>
  ),

  CONFIRM_RESET: "Are you sure you want to reset?",
  DATABASE_RESET_SUCCESS: "Database Reset Successfully",
  DATABASE_RESET_ERROR: "Error while Database Reset",
  ASYNC_ACTIVE_COUNT: "Background processes: ${activeCount}",
  SIGN_IN_CONTEXT_CHANGE: "You have changed your sign-in context. Your page will be reloaded",
};

export const en_message = function (key, hash = {}) {
  if (Object.keys(hash).length === 0 && hash.constructor === Object) {
    return MESSAGES[key];
  } else {
    let value = MESSAGES[key];
    Object.keys(hash).forEach(function (hashKey) {
      value = value.replace("${" + hashKey + "}", hash[hashKey]);
    });
    return value;
  }
};
